import {
  Authenticator,
  SelectField,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import CssBaseline from "@mui/material/CssBaseline";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { Amplify } from "aws-amplify";
import { signOut } from "aws-amplify/auth";
import { BrowserRouter } from "react-router-dom";
import { ToastContextProvider } from "./config/toast";
import Dashboard from "./pages/dashboard";

LicenseInfo.setLicenseKey(
  "26123a13820415a7226a0bd1db24034dTz0xMDgwMDIsRT0xNzcxMjg2Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);

const authConfig = {
  Cognito: {
    userPoolId: "us-west-1_MRRH7QyfO",
    userPoolClientId: "5qt0r318huub5gh0186csj59ui",
    identityPoolId: "us-west-1:24322939-b437-43d1-b846-8998c0d8f199",
  },
};

Amplify.configure({
  Auth: authConfig,
  Storage: {
    S3: {
      region: "us-west-1",
      bucket: "igniteinsightsbucketb2c1b-dev",
    },
  },
  API: {
    REST: {
      igniteinsights: {
        endpoint: "https://j5dk657cyb.execute-api.us-west-1.amazonaws.com/dev",
        region: "us-west-1",
      },
    },
  },
});

function DashboardWrapper() {
  const { user } = useAuthenticator((context) => [context.user]);
  return <Dashboard user={user} signOut={signOut} />;
}

export default function App({ user }) {
  return (
    <BrowserRouter>
      <Authenticator
        variation="modal"
        signUpAttributes={[
          "given_name",
          "family_name",
          "custom:team_number",
          "custom:role",
        ]}
        formFields={{
          signUp: {
            username: {
              label: "Email",
              placeholder: "Enter your email",
              isRequired: true,
              type: "email",
            },
            given_name: {
              label: "First Name",
              placeholder: "Enter your first name",
              isRequired: true,
              type: "text",
            },
            family_name: {
              label: "Last Name",
              placeholder: "Enter your last name",
              isRequired: true,
              type: "text",
            },
            "custom:team_number": {
              label: "Team Number",
              placeholder: "Enter your team number",
              isRequired: true,
              type: "text",
            },
            password: {
              label: "Password",
              placeholder: "Enter your password",
              isRequired: true,
              type: "password",
            },
            confirm_password: {
              label: "Confirm Password",
              placeholder: "Please confirm your password",
              isRequired: true,
              type: "password",
            },
          },
          signIn: {
            username: {
              label: "Email", // Change Username field to say Email
              placeholder: "Enter your email",
              isRequired: true,
              type: "email",
            },
          },
        }}
        components={{
          SignUp: {
            FormFields() {
              return (
                <>
                  <Authenticator.SignUp.FormFields />
                  <SelectField
                    label="Role"
                    name="custom:role"
                    isRequired
                    placeholder="Select your role"
                  >
                    <option value="2">Mentor</option>
                    <option value="3">Student</option>
                  </SelectField>
                </>
              );
            },
          },
        }}
      >
        <CssBaseline />
        <ToastContextProvider>
          <DashboardWrapper />
        </ToastContextProvider>
      </Authenticator>
    </BrowserRouter>
  );
}
